import { IconButton, IconName } from '@optimus-web/core';
import { DataTestId } from '@mews-commander/enums';
import { useDeleteCentralCancellationPolicyDialog } from '../../hooks';
import { WithCancellationPolicyId } from '../../../../cancellationPolicies';

interface HeaderActionsProps extends WithCancellationPolicyId {
    closeSidePanel: () => void;
}

export const HeaderActions = ({ cancellationPolicyId, closeSidePanel }: HeaderActionsProps) => {
    const { confirmationDialog, openConfirmationDialog } = useDeleteCentralCancellationPolicyDialog({
        onSuccess: closeSidePanel,
        cancellationPolicyId,
    });

    return (
        <>
            <IconButton
                data-test-id={DataTestId.DeleteCancellationPolicy}
                icon={IconName.Delete}
                onClick={openConfirmationDialog}
                size="small"
                type="submit"
            />
            {confirmationDialog}
        </>
    );
};
